<script>
export default {
    name: 'IconArrowheadDown'
}
</script>
<template>
    <svg
        class="base-icon icon-arrowhead-down"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M56 22.2L32.1 46l-.1-.1-.1.1L8 22.2l4.218-4.2L32 37.699 51.782 18z"
            fill-rule="evenodd"
        />
    </svg>
</template>
